<template>
  <div id="evaluate-guide">
    <div class="wrapper">
      <div class="image" v-for="(value, index) in images" :key="index">
        <img v-bind:src="value" />
        <div :id="forId(1,index)" class="content" ref="contentImage" v-show="index===3">
          <div :id="forId(2,index)" class="image-left" @click="showImage(0)"></div>
          <div :id="forId(3,index)" class="image-right" @click="showImage(1)"></div>
        </div>
        <div class="button" v-show="index===4" @click="evaluateClick">
        </div>
      </div>
    </div>
    <mt-popup v-model="imageVisible" position="center" class="image-popup" @click="hideImage">
      <img :src="pdfImages[index]" @click="hideImage">
    </mt-popup>
  </div>
</template>
<script>
import wxShare from '../wx/weixin.js'
export default{
  data () {
    return {
      imageVisible: false,
      images: [
        require('../assets/icon-eva1.jpg'),
        require('../assets/icon-eva2.jpg'),
        require('../assets/icon-eva3.jpg'),
        require('../assets/icon-eva4.jpg'),
        require('../assets/icon-eva5.jpg')],
      pdfImages: [
        require('../assets/icon-evaluate-1.jpg'),
        require('../assets/icon-evaluate-2.jpg')],
      index: 0
    }
  },
  methods: {
    forId: function (type, index) {
      if (type === 1) {
        return 'contentImage' + index
      }
      if (type === 2) {
        return 'image-left' + index
      }
      if (type === 3) {
        return 'image-right' + index
      }
    },
    showImage: function (index) {
      this.index = index
      this.imageVisible = true
    },
    hideImage: function () {
      this.imageVisible = false
    },
    evaluateClick: function () {
      // 统计
      this.utils.listenEvent(6, '', window.location.href, '')

      this.$router.push({path: 'evaluate-company'})
    },
    contentView: function () {
      var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      let width = winWidth - 20
      let height = (577.0 * width) / 706.0
      setTimeout(function () {
        document.getElementById('contentImage3').style.height = height + 'px'
        document.getElementById('image-left3').style.height = height - 60 + 'px'
        document.getElementById('image-right3').style.height = height - 60 + 'px'
      }, 500)
    },
    loadBaidu: function () { // 百度统计
      // var _hmt = _hmt || [];
      (function () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?3f11bb3581b33ddf79f464b3e70029cc'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }
  },
  mounted () {
    this.contentView()
    this.loadBaidu()
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
    // 统计
    this.utils.listenEvent(5, '', window.location.href, '')
  }
}
</script>

<style scoped>
  .wrapper{
    background-color: #F6F6F6;
    width: 100%;
  }
  .image{
    position: relative;
    margin-top: -1px;
  }
  img{
    position: relative;
    width: 100%;
    display: block;
  }
  .wrapper .content{
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    background-image: url(../assets/icon-eva4-bg.png);
    background-size: cover;
    background-position: center center;
    z-index: 110;
    /*background-color: yellowgreen;*/
  }
  .wrapper .content .image-left{
    position: absolute;
    top: 37px;
    left: 15px;
    width: calc(50% - 20px);
    height: 215px;
    background-image: url(../assets/icon-evaluate-1.jpg);
    background-size: cover;
    background-position: center center;
    z-index: 10;
  }
  .wrapper .content .image-right{
    position: absolute;
    top: 37px;
    right: 15px;
    width: calc(50% - 20px);
    height: 215px;
    background-image: url(../assets/icon-evaluate-2.jpg);
    background-size: cover;
    background-position: center center;
    z-index: 10;
  }
  .wrapper .button{
    position: absolute;
    top: 25px;
    left: calc(50% - 90px);
    width: 180px;
    height: 66px;
    background-image: url(../assets/icon-eva-go.png);
    background-size: cover;
    background-position: center center;
    z-index: 10;
  }
  .image-popup{
    width: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/view/evaluate-guide.vue